import React, {Dispatch, SetStateAction} from "react";
import Button from "@awsui/components-react/button";
import {useMutation} from "react-query";
import {FlashbarProps} from "@awsui/components-react/flashbar/interfaces";
import {useAuth} from "hooks/useAuth";
import User from "model/User";
import addPenalty from "api/addPenalty";


interface AddPenaltyButtonProps {
    userToPenalty: User;
    points: number;
    competitionCode: string;
    leagueId: number;
    setSubmitMessage: Dispatch<SetStateAction<FlashbarProps.MessageDefinition | undefined>>;
}

const AddPenaltyButton: React.FC<AddPenaltyButtonProps> = (props) => {

    const [{user}] = useAuth();
    const {userToPenalty, points, competitionCode, leagueId} = props;

    const {
        mutate: callAddPenalty,
        isLoading: setAddPenaltyIsLoading
    } = useMutation((penaltyUser: User) => addPenalty(penaltyUser, competitionCode, leagueId, points, user?.token), {
        onSuccess: () => {
            props.setSubmitMessage({
                header: "Penalty added correctly",
                type: "success",
                content: "",
            })
        },
        onError: () => {
            props.setSubmitMessage({
                header: "Error when adding penalty",
                type: "error",
                content: "Try to refresh the page.",
            })
        }
    });

    return (
        <Button
            iconAlign="left"
            loading={setAddPenaltyIsLoading}
            variant="normal"
            onClick={() => callAddPenalty(userToPenalty)}
        >
            Submit
        </Button>
    );
};

export default AddPenaltyButton;